export interface IStudyItem {
  backgroundImage: string
  buttomImage: string
  certificateId: string
  finishTaskNum: number
  gateImage: string
  gateLevel: number
  rateImage: string
  status: number // 关卡状态,1为未开始 2为学习中 3为已完成
  studymapGateId: string
  studymapId: string
  studymapName: string
  taskNum: number
}

export interface IMain {
  code: number | string
  body: IStudyItem[]
  message: string
}

export interface ITask {
  isObligatory: number
  resourceId: string
  resourceType: number
  // sortNo?: string
  status: number
  studymapGateTaskId: string
  taskName: string
  coursewareType: string
}
export interface ILevelItem {
  gateIntroduction: string
  gateName: string
  gatePassNum: number
  gateStatus: number
  isOrder: number
  studymapGateId: string
  studymapId: string
  taskList: ITask[]
  isOnTaskClassification: number
}

export interface ILevel {
  code: number
  body: ILevelItem
  message: string
}

export interface IRankItem {
  empName: string
  num: number
  photo: string
  sex: string
  userId: string
}
export interface IRank {
  body: {
    list: IRankItem[]
    myPhoto: string
    myRank: number
  }
  code: number
  message: string
}

export enum certificateTypeEnum {
  isCustom,
  isNotCustom,
}
export interface ICertificateBody {
  certificateRatio: string // "证书比例",example = "1:1 || 1.414:1"
  custCertificateType: number // 0为自定义证书，1为官方证书
  certificateImage: string
  completedDate: string
  empName: string
  enterpriseId: string
  name: string
  orgName: string
  studymapId: string
  time: string
  userId: string
}
export interface ICertificate {
  body: ICertificateBody
  code: number
  message: string
}

export interface ISourceBody {
  intgImage: string
  introduction: string
  resourceId: string
  resourceType: number
  status: any
}

export interface ISource {
  body: ISourceBody
  code: 0
  message: string
}
